// Monstres procéduraux : silhouettes distinctes par archétype (pas seulement par couleur).
import { Graphics } from 'pixi.js';
import { colors } from '../colors';

export const ZONE_RIM = [0x8d99a6, 0x4fd18a, 0xf0a04a, 0xff5a4a, 0xb48cff];
const BODY = 0x2a2430;
const OUTLINE = 0x0d0b10;

/** Dessine un monstre de rayon r. arch : 0 Bastion, 1 Faucheur, 2 Sentinelle, 3 Chimère. */
export function drawMonster(g: Graphics, arch: number, zone: number, r: number): void {
  const rims = colors().zoneRim;
  const rim = rims[zone] ?? rims[1];
  g.clear();
  if (arch === 0 || arch === 3) {
    // Bastion : carapace hexagonale à plaques et pointes.
    for (let i = 0; i < 6; i++) {
      const a = (i * Math.PI) / 3;
      g.poly([Math.cos(a - 0.18) * r * 0.95, Math.sin(a - 0.18) * r * 0.95, Math.cos(a) * r * 1.22, Math.sin(a) * r * 1.22, Math.cos(a + 0.18) * r * 0.95, Math.sin(a + 0.18) * r * 0.95])
        .fill(rim)
        .stroke({ width: 2, color: OUTLINE });
    }
    g.regularPoly(0, 0, r, 6, 0).fill(BODY).stroke({ width: 3, color: OUTLINE });
    g.regularPoly(0, 0, r * 0.68, 6, 0).fill(0x3a3242).stroke({ width: 2, color: rim, alpha: 0.9 });
    g.regularPoly(0, 0, r * 0.3, 6, 0).fill(rim);
  }
  if (arch === 1 || arch === 3) {
    // Faucheur : corps effilé et deux lames latérales (orienté vers +x).
    const k = arch === 3 ? 0.75 : 1;
    for (const side of [-1, 1]) {
      g.poly([r * 0.1 * k, side * r * 0.3, r * 1.15 * k, side * r * 1.05, r * 0.55 * k, side * r * 0.35]).fill(rim).stroke({ width: 2, color: OUTLINE });
    }
    if (arch === 1) {
      g.poly([r * 1.1, 0, -r * 0.7, r * 0.62, -r * 0.4, 0, -r * 0.7, -r * 0.62]).fill(BODY).stroke({ width: 3, color: OUTLINE });
      g.poly([r * 0.7, 0, -r * 0.2, r * 0.3, -r * 0.2, -r * 0.3]).fill(rim);
    }
  }
  if (arch === 2 || arch === 3) {
    // Sentinelle : œil rond, ailerons et iris qui regarde la cible.
    const k = arch === 3 ? 0.55 : 1;
    if (arch === 2) {
      for (let i = 0; i < 3; i++) {
        const a = Math.PI + (i - 1) * 0.9;
        g.poly([Math.cos(a - 0.25) * r * 0.8, Math.sin(a - 0.25) * r * 0.8, Math.cos(a) * r * 1.3, Math.sin(a) * r * 1.3, Math.cos(a + 0.25) * r * 0.8, Math.sin(a + 0.25) * r * 0.8])
          .fill(rim)
          .stroke({ width: 2, color: OUTLINE });
      }
      g.circle(0, 0, r).fill(BODY).stroke({ width: 3, color: OUTLINE });
    }
    g.circle(r * 0.18 * k, 0, r * 0.5 * k).fill(0xf2eee6).stroke({ width: 2, color: OUTLINE });
    g.circle(r * 0.36 * k, 0, r * 0.24 * k).fill(rim);
    g.circle(r * 0.42 * k, 0, r * 0.1 * k).fill(OUTLINE);
  }
}

/** Télégraphe d'attaque (dessiné dans le repère du monde, centré sur le monstre). */
export function drawTelegraph(g: Graphics, code: number, r: number, angle: number, pulse: number): void {
  g.clear();
  const alpha = 0.35 + 0.35 * pulse;
  switch (code) {
    case 1: // corps à corps
      g.circle(0, 0, r + 26).stroke({ width: 4, color: 0xff5a4a, alpha });
      break;
    case 2: // tir visé
    case 5: {
      // salve
      const len = 700;
      const spread = code === 5 ? [-0.32, -0.16, 0, 0.16, 0.32] : [0];
      for (const s of spread) {
        const a = angle + s;
        g.moveTo(Math.cos(a) * r, Math.sin(a) * r).lineTo(Math.cos(a) * len, Math.sin(a) * len).stroke({ width: 3, color: 0xffb04a, alpha });
      }
      break;
    }
    case 3: // onde de choc
      g.circle(0, 0, r + 260).fill({ color: 0xff5a4a, alpha: 0.08 + 0.1 * pulse }).stroke({ width: 5, color: 0xff5a4a, alpha });
      break;
    case 4: {
      // charge
      const len = r + 520;
      const w = r * 0.9;
      const c = Math.cos(angle);
      const s = Math.sin(angle);
      g.poly([-s * w, c * w, c * len - s * w, s * len + c * w, c * len + s * w, s * len - c * w, s * w, -c * w]).fill({ color: 0xff5a4a, alpha: 0.12 + 0.12 * pulse }).stroke({ width: 3, color: 0xff5a4a, alpha });
      break;
    }
  }
}
